import { __ } from '@wordpress/i18n';
import { GradientPicker } from '@wordpress/components';
import { useState,useEffect } from '@wordpress/element';
import { VayuBlocksBlockEditor } from '@vayu-blocks/global';

 export const VayuBlocksGradient = ({ onChange, background} ) => {
    const { value, backgroundKey } = background;
  const blockEditor = VayuBlocksBlockEditor();
  const [colors, setColors] = useState([]);
  
  useEffect(() => {
      setColors([
          
          {
              name: 'DEFAULT',
              gradients: [
                  {
                      gradient: 'linear-gradient(135deg,rgba(6,147,227,1) 0%,rgb(155,81,224) 100%)',
                      name: 'Vivid cyan blue to vivid purple',
                      slug: 'vivid-cyan-blue-to-vivid-purple',
                  },
                  {
                    gradient: 'linear-gradient(90deg, rgba(192,156,135,0.2) 23.54%, rgba(192,250,118,0.2) 42.64%, rgba(118,162,250,0.2) 62.38%, rgba(160,118,250,0.2) 77.26%, rgba(250,118,149,0.2) 85.68%)',
                    name: 'Vivid cyan different',
                    slug: 'vivid-cyan-different',
                  },
                  {
                      gradient: 'linear-gradient(135deg,rgb(122,220,180) 0%,rgb(0,208,130) 100%)',
                      name: 'Light green cyan to vivid green cyan',
                      slug: 'light-green-cyan-to-vivid-green-cyan',
                  },
                  {
                      gradient: 'linear-gradient(135deg,rgba(252,185,0,1) 0%,rgba(255,105,0,1) 100%)',
                      name: 'Luminous vivid amber to luminous vivid orange',
                      slug: 'luminous-vivid-amber-to-luminous-vivid-orange',
                  },
                  {
                      gradient: 'linear-gradient(135deg,rgba(255,105,0,1) 0%,rgb(207,46,46) 100%)',
                      name: 'Luminous vivid orange to vivid red',
                      slug: 'luminous-vivid-orange-to-vivid-red',
                  },
                  {
                      gradient: 'linear-gradient(135deg,rgb(238,238,238) 0%,rgb(169,184,195) 100%)',
                      name: 'Very light gray to cyan bluish gray',
                      slug: 'very-light-gray-to-cyan-bluish-gray',
                  },
                  {
                      gradient: 'linear-gradient(135deg,rgb(74,234,220) 0%,rgb(151,120,209) 20%,rgb(207,42,186) 40%,rgb(238,44,130) 60%,rgb(251,105,98) 80%,rgb(254,248,76) 100%)',
                      name: 'Cool to warm spectrum',
                      slug: 'cool-to-warm-spectrum',
                  },
              ],
          },{
            name: 'THEME COLOR',
            gradients: blockEditor.gradients,
        }
      ]);
  }, [blockEditor]);
  
      return (
            <GradientPicker
                value={ value?.gradient }
                gradients={colors}
                enableAlpha
                onChange={(newColor) => {
                const updatedValue = {
                    ...value,
                    gradient: newColor,
                };
                onChange(backgroundKey, updatedValue);
            }}
            />
      );
}
